(function () {
  "use strict";

  if (window.__tfLiveStates) return;

  var AVAILABLE = Object.freeze({
    available: true,
    label: "Available"
  });
  var UNAVAILABLE = Object.freeze({
    available: false,
    label: "Temporarily unavailable"
  });
  var STATE_AVAILABILITY = Object.freeze({
    ACT: AVAILABLE,
    NT: AVAILABLE,
    SA: AVAILABLE,
    TAS: AVAILABLE,
    NSW: AVAILABLE,
    WA: AVAILABLE,
    QLD: UNAVAILABLE,
    VIC: UNAVAILABLE
  });
  var UNAVAILABLE_MESSAGE =
    "Title searches for this state are temporarily unavailable. Please check back soon.";
  var STATE_LANDING = Object.freeze({
    ACT: "/products/act-certificate-of-title",
    NT: "/products/nt-title-search",
    SA: "/products/sa-title-register-search",
    TAS: "/products/tas-folio-text",
    NSW: "/products/nsw-title-search",
    WA: "/products/wa-title-search"
  });
  var QLD_HANDLES = Object.freeze({
    "current-title": true,
    "historical-title-search": true,
    "certificate-of-title-pre-1994": true,
    "cadastral-survey-plan-survey-sheet": true,
    "dealing-instruments": true,
    "pre-purchase-diligence-package": true
  });
  var BLOCKED_VARIANTS = Object.freeze({
    47097759564035: "QLD",
    47097759629571: "QLD",
    47097759695107: "QLD",
    47097759727875: "QLD",
    47097759793411: "QLD",
    47097759891715: "QLD",
    47874873262339: "VIC",
    47874873295107: "VIC",
    47874873327875: "VIC",
    47874873360643: "VIC",
    47874873393411: "VIC"
  });

  function normalizeState(state) {
    return String(state || "").trim().toUpperCase();
  }

  function availabilityFor(state) {
    return STATE_AVAILABILITY[normalizeState(state)] || UNAVAILABLE;
  }

  function stateForControl(control) {
    return normalizeState(
      control.getAttribute("data-state") ||
        control.getAttribute("data-tf-state")
    );
  }

  function decorateStateControl(control) {
    var state = stateForControl(control);
    if (availabilityFor(state).available) return false;
    control.disabled = true;
    control.setAttribute("aria-disabled", "true");
    control.setAttribute(
      "aria-describedby",
      "tf-state-unavailable-message"
    );
    if (control.hasAttribute("onclick")) {
      control.setAttribute(
        "data-tf-original-onclick",
        control.getAttribute("onclick") || ""
      );
      control.removeAttribute("onclick");
    }
    control.classList.add("tf-state-availability--disabled");
    if (!control.querySelector(".tf-state-availability__badge")) {
      var badge = document.createElement("span");
      badge.className = "tf-state-availability__badge";
      badge.textContent = UNAVAILABLE.label;
      control.appendChild(badge);
    }
    return true;
  }

  function stateFromAddress(address) {
    var text = " " + String(address || "").toUpperCase() + " ";
    var explicit = text.match(/\b(ACT|TAS|NT|SA|NSW|VIC|WA|QLD)(?:\s+\d{4})?(?:\s*,?\s*AUSTRALIA)?\s*$/) ||
      text.match(/\b(ACT|TAS|NT|SA|NSW|VIC|WA|QLD)\s+\d{4}\b/);
    if (explicit) return explicit[1];
    if (/\bACT\b|AUSTRALIAN CAPITAL TERRITORY|\bCANBERRA\b/.test(text)) {
      return "ACT";
    }
    if (/\bTAS\b|TASMANIA|\bHOBART\b|\bLAUNCESTON\b/.test(text)) {
      return "TAS";
    }
    if (/\bNT\b|NORTHERN TERRITORY|\bDARWIN\b|\bALICE SPRINGS\b/.test(text)) {
      return "NT";
    }
    if (/\bSA\b|SOUTH AUSTRALIA|\bADELAIDE\b/.test(text)) return "SA";
    if (/\bNSW\b|NEW SOUTH WALES|\bSYDNEY\b/.test(text)) return "NSW";
    if (/\bVIC\b|VICTORIA|\bMELBOURNE\b/.test(text)) return "VIC";
    if (/\bWA\b|WESTERN AUSTRALIA|\bPERTH\b/.test(text)) return "WA";
    if (/\bQLD\b|QUEENSLAND|\bBRISBANE\b/.test(text)) return "QLD";
    return null;
  }

  function routeForAddress(address) {
    var state = stateFromAddress(address);
    if (!state) return Object.freeze({ kind: "unknown" });
    if (!availabilityFor(state).available) {
      return Object.freeze({ kind: "unavailable", state: state });
    }
    return Object.freeze({
      kind: "available",
      state: state,
      path: STATE_LANDING[state]
    });
  }

  function stateForProductHandle(handle) {
    var normalized = String(handle || "").toLowerCase();
    if (QLD_HANDLES[normalized]) return "QLD";
    var match = normalized.match(/^(act|nt|sa|tas|nsw|vic|wa|qld)-/);
    return match ? match[1].toUpperCase() : null;
  }

  function currentProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function blockedVariantState(id) {
    return BLOCKED_VARIANTS[parseInt(id, 10)] || null;
  }

  function addressError(address, expectedState, stateCode) {
    var state = normalizeState(stateCode) || stateFromAddress(address);
    if (!state) return null;
    if (!availabilityFor(state).available) return UNAVAILABLE_MESSAGE;
    if (expectedState && state !== expectedState) {
      return "This product is for " + expectedState + ". Your property address is in " + state +
        ". Please correct the address or choose the " + state + " product before continuing.";
    }
    return null;
  }

  function payloadError(body, expectedState) {
    function itemError(item) {
      if (!item) return null;
      if (blockedVariantState(item.id || item.variant_id)) return UNAVAILABLE_MESSAGE;
      return addressError((item.properties || {})["Property Address"], expectedState);
    }
    try {
      if (!body) return null;
      if (typeof body === "string") body = JSON.parse(body);
      if (
        (typeof FormData !== "undefined" && body instanceof FormData) ||
        (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams)
      ) {
        var error = null;
        body.forEach(function (value, key) {
          if (/^id$|variant/i.test(key) && blockedVariantState(value)) error = UNAVAILABLE_MESSAGE;
          if (/address/i.test(key)) error = error || addressError(value, expectedState);
        });
        return error;
      }
      if (typeof body === "object") {
        var directError = itemError(body);
        if (directError) return directError;
        var items = Array.isArray(body.items) ? body.items : [];
        for (var i = 0; i < items.length; i++) {
          var error = itemError(items[i]);
          if (error) return error;
        }
      }
    } catch (error) {
      return null;
    }
    return null;
  }

  function payloadHasBlockedVariant(body) {
    return Boolean(payloadError(body, stateForProductHandle(currentProductHandle())));
  }

  function ensureStyles() {
    if (document.getElementById("tf-state-availability-style")) return;
    var style = document.createElement("style");
    style.id = "tf-state-availability-style";
    style.textContent = [
      ".tf-state-availability--disabled{opacity:.5!important;cursor:not-allowed!important;filter:grayscale(.35)}",
      ".tf-state-availability__notice:not(:empty){margin:10px 0;padding:12px;border:1px solid #b91c1c;border-radius:6px;background:#fff7f7;color:#991b1b;font-size:14px;line-height:1.5}",
      ".tf-state-availability--disabled .tf-state-availability__badge{display:block;margin-top:3px;font-size:10px;font-weight:700;line-height:1.15;white-space:normal}",
      ".tf-state-availability__sr{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}"
    ].join("");
    document.head.appendChild(style);
  }

  function ensureSharedMessage() {
    if (document.getElementById("tf-state-unavailable-message")) return;
    var message = document.createElement("span");
    message.id = "tf-state-unavailable-message";
    message.className = "tf-state-availability__sr";
    message.textContent = UNAVAILABLE_MESSAGE;
    document.body.appendChild(message);
  }

  function showUnavailableNotice(input, message) {
    var existing = document.getElementById("tf-state-unavailable-alert");
    var alert = existing || document.createElement("div");
    alert.id = "tf-state-unavailable-alert";
    alert.setAttribute("role", "status");
    alert.setAttribute("aria-live", "polite");
    alert.className = "tf-state-availability__notice";
    alert.textContent = message || UNAVAILABLE_MESSAGE;
    if (!existing) {
      var parent = input && input.parentElement;
      if (parent) parent.insertBefore(alert, input.nextSibling);
      else (document.querySelector("main") || document.body).appendChild(alert);
    }
    return alert;
  }

  function handleAddressResult(input, address, stateCode) {
    var error = addressError(address, stateForProductHandle(currentProductHandle()), stateCode);
    if (!error) {
      var notice = document.getElementById("tf-state-unavailable-alert");
      if (notice) notice.textContent = "";
      return true;
    }
    if (input) input.value = address;
    showUnavailableNotice(input, error);
    return false;
  }

  function decorateAllStateControls() {
    ensureStyles();
    ensureSharedMessage();
    document
      .querySelectorAll("button[data-state], [data-tf-state]")
      .forEach(decorateStateControl);
  }

  function guardUnavailableControl(event) {
    var control =
      event.target &&
      event.target.closest &&
      event.target.closest("button[data-state], [data-tf-state]");
    if (!control || availabilityFor(stateForControl(control)).available) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function installControlGuard() {
    document.addEventListener("click", function (event) {
      var button = event.target && event.target.closest && event.target.closest("#buy-now-button");
      var input = document.getElementById("product-address-input");
      if (button && input && !handleAddressResult(input, input.value)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        input.focus();
        input.scrollIntoView({ block: "center" });
      }
    }, true);
    document.addEventListener("click", guardUnavailableControl, true);
    document.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        guardUnavailableControl(event);
      }
    }, true);
  }

  function gateProductPage() {
    var state = stateForProductHandle(currentProductHandle());
    if (!state || availabilityFor(state).available) return false;
    document.documentElement.setAttribute("data-tf-gated-state", state);
    var button = document.getElementById("buy-now-button");
    if (button) {
      button.disabled = true;
      button.textContent = "Temporarily unavailable";
      button.setAttribute("aria-disabled", "true");
      button.setAttribute(
        "aria-describedby",
        "tf-state-unavailable-message"
      );
    }
    document
      .querySelectorAll(
        [
          'form[action*="/cart/add"]',
          ".shopify-payment-button",
          "[data-atc-form]",
          ".t4s-product-form__buttons",
          ".t4s-sticky-atc",
          "#t4s-sticky-atc"
        ].join(",")
      )
      .forEach(function (element) {
        element.style.display = "none";
      });
    showUnavailableNotice(button);
    return true;
  }

  function installFetchGuard() {
    if (!window.fetch || window.fetch.__tfStateAvailabilityGuard) return;
    var originalFetch = window.fetch;
    var guardedFetch = function (url, options) {
      var target = typeof url === "string" ? url : (url && url.url) || "";
      var pageState = stateForProductHandle(currentProductHandle());
      if (target.indexOf("/cart/add") !== -1) {
        var error = pageState && !availabilityFor(pageState).available
          ? UNAVAILABLE_MESSAGE : payloadError(options && options.body, pageState);
        if (error) {
          showUnavailableNotice(document.getElementById("product-address-input"), error);
          return Promise.reject(new Error(error));
        }
      }
      return originalFetch.apply(this, arguments);
    };
    guardedFetch.__tfStateAvailabilityGuard = true;
    window.fetch = guardedFetch;
  }

  function cartError(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (blockedVariantState(item.variant_id || item.id)) return UNAVAILABLE_MESSAGE;
      var error = addressError((item.properties || {})["Property Address"], stateForProductHandle(item.handle));
      if (error) return error;
    }
    return null;
  }

  function guardCartCheckout() {
    if (window.location.pathname.indexOf("/cart") !== 0 || !window.fetch) {
      return;
    }
    if (wireCartAddresses()) return;
    window
      .fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        var error = cartError(cart);
        if (!error) return;
        showUnavailableNotice(null, error);
        document
          .querySelectorAll(
            'a[href*="/checkout"], button[name="checkout"], input[name="checkout"]'
          )
          .forEach(function (element) {
            element.disabled = true;
            element.setAttribute("aria-disabled", "true");
            element.style.pointerEvents = "none";
            element.style.opacity = "0.55";
          });
      })
      .catch(function () {});
  }

  function cartAddressChange(item, address) {
    address = String(address || "").trim();
    if (!item || !item.key || !address) throw new Error("Missing cart item or address");
    var error = blockedVariantState(item.variant_id || item.id)
      ? UNAVAILABLE_MESSAGE : addressError(address, stateForProductHandle(item.handle));
    if (error) throw new Error(error);
    return { id: item.key, properties: Object.assign({}, item.properties || {}, { "Property Address": address }) };
  }

  function cartAddressAttribute(cart) {
    var addresses = [];
    (cart.items || []).forEach(function (item) {
      var address = String((item.properties || {})["Property Address"] || "").trim();
      if (address && addresses.indexOf(address) === -1) addresses.push(address);
    });
    return addresses.length === 1 ? addresses[0] : "";
  }

  function wireCartAddresses() {
    var root = document.querySelector("[data-tf-cart-editor]");
    if (!root || !window.fetch) return false;
    var rows = Array.prototype.slice.call(root.querySelectorAll("[data-tf-cart-address]"));
    if (!rows.length) return false;
    var checkout = document.getElementById("tf-cart-checkout");
    var consent = document.getElementById("tf-cart-legal-consent");
    var status = root.querySelector("[data-cart-status]");
    var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var currentCart = null;
    var busy = true;
    var failed = false;
    var forwardingCheckout = false;
    function message(key) { return root.getAttribute("data-message-" + key) || ""; }
    function inputFor(row) { return row.querySelector("input"); }
    function dirty(row) { return inputFor(row).value.trim() !== row.getAttribute("data-saved-address"); }
    function rowError(row) {
      var address = inputFor(row).value.trim();
      return !address ? message("required") : addressError(address, stateForProductHandle(row.getAttribute("data-product-handle")));
    }
    function problem() {
      if (failed) return message("failed");
      if (busy || !currentCart) return message("saving");
      for (var i = 0; i < rows.length; i++) {
        var error = rowError(rows[i]);
        if (error) return error;
        if (dirty(rows[i])) return message("unsaved");
      }
      return cartError(currentCart);
    }
    function render() {
      rows.forEach(function (row) {
        var input = inputFor(row);
        var error = rowError(row);
        input.disabled = busy || failed;
        input.setAttribute("aria-invalid", error ? "true" : "false");
        row.querySelector("button").disabled = busy || failed || !dirty(row) || Boolean(error);
        row.querySelector("[data-address-status]").textContent = error || (dirty(row) ? message("unsaved") : "");
      });
      root.querySelectorAll(".tf-cart-item__instrument-input, .tf-cart-item__remove").forEach(function (control) {
        control.disabled = busy || failed;
      });
      var error = problem();
      status.textContent = error || "";
      var disabled = Boolean(error) || !consent || !consent.checked;
      if (checkout) {
        checkout.setAttribute("aria-disabled", String(disabled));
        checkout.classList.toggle("tf-cart-actions__checkout--disabled", disabled);
      }
    }
    function request(path, payload) {
      var options = { credentials: "same-origin", cache: "no-store" };
      if (payload) {
        options.method = "POST";
        options.headers = { "Content-Type": "application/json", Accept: "application/json" };
        options.body = JSON.stringify(payload);
      }
      return window.fetch(route + path, options).then(function (response) {
        if (!response.ok) throw new Error("Cart request failed");
        return response.json();
      }).then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) throw new Error("Invalid cart response");
        return cart;
      });
    }
    function syncAttribute(cart) {
      var address = cartAddressAttribute(cart);
      if (((cart.attributes || {})["Property Address"] || "") === address) return Promise.resolve(cart);
      return request("cart/update.js", { attributes: { "Property Address": address } }).then(function (updated) {
        if (((updated.attributes || {})["Property Address"] || "") !== address) throw new Error("Address not confirmed");
        return updated;
      });
    }
    function confirmRows(cart) {
      if (cart.items.length !== rows.length) throw new Error("Cart structure changed");
      rows.forEach(function (row) {
        var item = cart.items.find(function (entry) { return entry.key === row.getAttribute("data-item-key"); });
        if (!item || String((item.properties || {})["Property Address"] || "").trim() !== row.getAttribute("data-saved-address")) {
          throw new Error("Cart changed; reload required");
        }
      });
      return cart;
    }
    function stop() { busy = false; failed = true; render(); }
    rows.forEach(function (row) {
      var input = inputFor(row);
      input.addEventListener("input", render);
      row.querySelector("button").addEventListener("click", function () {
        if (busy || failed || rowError(row) || !dirty(row)) return;
        var address = input.value.trim();
        var item;
        var payload;
        busy = true;
        render();
        request("cart.js").then(confirmRows).then(function (cart) {
          item = cart.items.find(function (entry) { return entry.key === row.getAttribute("data-item-key"); });
          payload = cartAddressChange(item, address);
          return request("cart/change.js", payload);
        }).then(syncAttribute).then(function (cart) {
          var updated = cart.items.filter(function (entry) {
            var properties = entry.properties || {};
            return entry.variant_id === item.variant_id && Object.keys(properties).length === Object.keys(payload.properties).length &&
              Object.keys(payload.properties).every(function (key) { return properties[key] === payload.properties[key]; });
          });
          if (updated.length !== 1 || cart.items.length !== rows.length) throw new Error("Cart structure changed");
          row.setAttribute("data-item-key", updated[0].key);
          row.setAttribute("data-saved-address", address);
          input.value = address;
          var quantity = row.closest(".tf-cart-item").querySelector(".tf-cart-item__instrument-input");
          if (quantity) quantity.setAttribute("data-item-key", updated[0].key);
          currentCart = confirmRows(cart);
          busy = false;
          render();
          row.querySelector("[data-address-status]").textContent = message("saved");
        }).catch(stop);
      });
    });
    root.addEventListener("change", function (event) {
      if (event.target === consent) render();
    });
    root.addEventListener("submit", function (event) {
      if (busy) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    if (checkout) checkout.addEventListener("click", function (event) {
      if (forwardingCheckout) return;
      if (!consent || !consent.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (problem()) { render(); return; }
      busy = true;
      render();
      request("cart.js").then(confirmRows).then(syncAttribute).then(function (cart) {
        currentCart = cart;
        busy = false;
        render();
        if (!problem() && consent.checked) {
          forwardingCheckout = true;
          checkout.click();
          forwardingCheckout = false;
        }
      }).catch(stop);
    }, true);
    render();
    request("cart.js").then(confirmRows).then(syncAttribute).then(function (cart) {
      currentCart = cart;
      busy = false;
      render();
    }).catch(stop);
    return true;
  }

  function routeAddressSearch() {
    if (window.location.pathname !== "/collections/titles") return;
    var address = new URLSearchParams(window.location.search).get("address");
    if (!address) return;
    var route = routeForAddress(address);
    if (route.kind === "unavailable") {
      showUnavailableNotice(document.getElementById("tf-hero-addr"));
      return;
    }
    if (route.kind === "available") {
      window.location.replace(
        route.path + "?address=" + encodeURIComponent(address)
      );
    }
  }

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  window.__tfLiveStates = Object.freeze({
    availabilityFor: availabilityFor,
    decorateStateControl: decorateStateControl,
    handleAddressResult: handleAddressResult,
    cartError: cartError,
    cartAddressChange: cartAddressChange,
    cartAddressAttribute: cartAddressAttribute,
    payloadHasBlockedVariant: payloadHasBlockedVariant,
    routeForAddress: routeForAddress,
    stateForProductHandle: stateForProductHandle,
    stateFromAddress: stateFromAddress,
    unavailableMessage: UNAVAILABLE_MESSAGE
  });

  installControlGuard();
  installFetchGuard();
  routeAddressSearch();
  ready(function () {
    var reference = new URLSearchParams(window.location.search).get("ref");
    var referenceInput = document.getElementById("product-address-input");
    if (reference && referenceInput && !referenceInput.value) referenceInput.value = reference;
    decorateAllStateControls();
    gateProductPage();
    guardCartCheckout();
    window.setTimeout(gateProductPage, 400);
    window.setTimeout(gateProductPage, 1200);
  });
  window.addEventListener("load", gateProductPage);
})();
